import { render } from "./index.vue?vue&type=template&id=53579a7f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=53579a7f&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53579a7f"],['__file',"src/components/FormularioBaseEndereco/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53579a7f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53579a7f', __exports__)) {
    console.log('reload')
    api.reload('53579a7f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=53579a7f&scoped=true", () => {
    console.log('re-render')
    api.rerender('53579a7f', render)
  })

}


export default __exports__